import { Controller } from "@hotwired/stimulus";

export default class LinkController extends Controller {

    navigate(event) {
        const selection = globalThis.getSelection()
        if (selection && !selection.isCollapsed) {
            return;
        }

        // access the post description link without open the show page
        if (event.target.closest("a")) {
            return;
        }

        if (event.target.closest('.inner-link')) {
            return;
        }

        if (event.target.closest('.dropdown')){
            return;
        }

        event.preventDefault();

        const href = this.element.getAttribute("href");
        const turbo = this.element.dataset.turbo;
        if (turbo === 'true') {
            fetch(href, {
                method: 'get',
                headers: {
                    Accept: 'text/vnd.turbo-stream.html',
                }
            })
            .then((r) => r.text())
            .then((html) => {
                Turbo.renderStreamMessage(html)
            })
            return;
        }

        if (href) {
            Turbo.visit(href);
        }
    }


}